<template>
  <div>
    <div class="grid-schedule-cell">
      <span v-if="data.scheduleActive === 'Active'">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          size="xs"
          class="success"
          transform="shrink-4"
        />
        Scheduled Active
      </span>
      <span v-if="data.scheduleActive === 'Inactive'">
        <font-awesome-icon
          :icon="['fas', 'circle']"
          size="xs"
          class="danger"
          transform="shrink-4"
        />
        Scheduled Inactive
      </span>
      <span v-if="data.scheduleActive !== 'Active' && data.scheduleActive !== 'Inactive'">
        {{ data.statusCampaignTranslated }}
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import eInsightUrl from '@/constants/eInsightUrl'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
  moment
})

export default {
  name: 'GridSchedule',
  data () {
    return {
      data: {},
      cssClass: 'customtip',
      target: '#app',
      height: '',
      width: '400px',
      toastPosition: { X: 'Right', Y: 'Top' },
      animationSettings: { effect: 'Fade', duration: 100 },
      eInsightUrl: eInsightUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-schedule-cell:hover {
  cursor: pointer;
}
a.tooltip-link, .link-default {
  text-decoration: none;
  color: #666;
}
.success {
  color: $success;
}
.danger {
  color: $danger;
}
.unset {
  color: $gray-medium;
}
.svg-inline--fa {
  vertical-align: 0;
}
</style>
